var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    _vm._b(
      {
        class: _vm.classes.form,
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.formSubmitted.apply(null, arguments)
          }
        }
      },
      "form",
      _vm.attributes,
      false
    ),
    [
      _vm.schema
        ? _c(
            "FormulateSchema",
            _vm._g({ attrs: { schema: _vm.schema } }, _vm.schemaListeners)
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.hasFormErrorObservers
        ? _c("FormulateErrors", { attrs: { context: _vm.formContext } })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default", null, null, _vm.formContext)
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }